import { $,_,moment } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'
import { Notification } from '../../utils'

import PricediscountsItemTpl from '../../templates/pricediscounts/PricediscountsItemTpl.html'

const PricediscountsItemView = InboomaBaseView.extend({

  template : PricediscountsItemTpl,
  className : 'inb-c-item inb-c-item--pricediscount row',

  ui : {
      dropdown : '.inb-dropdown',
      pricediscountEdit : '.inb-pricediscount__edit',
      pricediscountRemove : '.inb-pricediscount-remove'
  },

  events : {
    'click .inb-pricediscount-remove' : '_removePricediscount'
  },

  initialize () {

    const that = this;

    this.model.on('changed', () => {
      that.render();
    });

  },

  templateContext () {
      return {
          _,
          moment
      }
  },

    _removePricediscount (target) {

        const that = this;

        if (confirm(this.t('really_remove'))) {
            this.model.destroy({
                
                success (model, repsonse) {

                    that.$el.fadeOut('fast');
                    new Notification({
                        message : that.t('removed_${a}',{a:that.t('pricediscount')},'capital'),
                        duration : 5000,
                        closeable : true,
                        icon : 'fi fi-trash'
                    });

                }
            });
        };

    },

});

export default InboomaBaseCollectionView.extend({

  childView: PricediscountsItemView,
  template : _.noop,

  initialize () {

      this.render();
    
  },
    onRender() {
        $('.inb-c-loader').remove();
    }

});
